import { EnvironmentUrls } from 'Roblox';

const { gamesApi, thumbnailsApi } = EnvironmentUrls;
export default {
  gamesPageSortName: 'GamesDefaultSorts',
  pageSize: 40,
  getGameSortsWithDetaultSorts: {
    url: `${gamesApi}/v1/games/sorts`,
    withCredentials: true
  },
  getGamesList: {
    url: `${gamesApi}/v1/games/list`,
    withCredentials: true
  },
  getGameThumbnails: {
    url: `${thumbnailsApi}/v1/games/multiget/thumbnails`
  },
  getGameMedias(universeId) {
    return {
      url: `${gamesApi}/v2/games/${universeId}/media`,
      withCredentials: true
    };
  },
  params: {
    sortToken: null,
    keyword: null,
    exclusiveStartId: null,
    isKeywordSuggestionEnabled: true,
    hasMoreRows: true,
    startRows: 0,
    maxRows: 60,
    gameSetTargetId: null
  }
};
